var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRegex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_regex") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ui-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ASSETS",
    transform: "translate(-200, -40)",
    fill: "#324149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_regex",
    transform: "translate(200, 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14 C0,12.895 0.895,12 2,12 C3.105,12 4,12.895 4,14 C4,15.105 3.105,16 2,16 C0.895,16 0,15.105 0,14 L0,14 Z M11,11.92 C10.67,11.97 10.34,12 10,12 C9.66,12 9.33,11.97 9,11.92 L9,8.41 L6.5,10.89 C6,10.5 5.5,10 5.11,9.5 L7.59,7 L4.08,7 C4.03,6.67 4,6.34 4,6 C4,5.66 4.03,5.33 4.08,5 L7.59,5 L5.11,2.5 C5.3,2.25 5.5,2 5.76,1.76 C6,1.5 6.25,1.3 6.5,1.11 L9,3.59 L9,0.08 C9.33,0.03 9.66,0 10,0 C10.34,0 10.67,0.03 11,0.08 L11,3.59 L13.5,1.11 C14,1.5 14.5,2 14.89,2.5 L12.41,5 L15.92,5 C15.97,5.33 16,5.66 16,6 C16,6.34 15.97,6.67 15.92,7 L12.41,7 L14.89,9.5 C14.7,9.75 14.5,10 14.24,10.24 C14,10.5 13.75,10.7 13.5,10.89 L11,8.41 L11,11.92 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegex);
export default __webpack_public_path__ + "static/media/ic_regex.488d9543510242ccbd4e372580acc9f6.svg";
export { ForwardRef as ReactComponent };